export default __webpack_public_path__ + "static/media/bg-pattern.ac56185f.png";